import sculptureImage1 from "../assets/images/sculptors/sculpture1.png";
import sculptureImage2 from "../assets/images/sculptors/sculpture2.png";
import sculptureImage3 from "../assets/images/sculptors/sculpture3.png";

export const sculptures = [
  {
    id: 1,
    image: sculptureImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 2,
    image: sculptureImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 3,
    image: sculptureImage3,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 4,
    image: sculptureImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 5,
    image: sculptureImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 6,
    image: sculptureImage3,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 7,
    image: sculptureImage1,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
  {
    id: 8,
    image: sculptureImage2,
    title: "Title Of Artwork",
    artistFullName: "John Doe",
    country: "Artsakh",
    sizes: "120x150",
    material: "Oil",
    price: "€2.805",
  },
];
